const readEnv = (key) => (process.env[key] || '').trim();

const resolveAppOrigin = () => {
  if (typeof window === 'undefined') return '';
  return window.location?.origin || '';
};

const withFallback = (value, fallback) => (value && value.trim() ? value.trim() : fallback);

export const CONFIG = {
  API_BASE_URL: withFallback(readEnv('REACT_APP_API_BASE_URL'), resolveAppOrigin()),
  AHM_KPI_REPORT_URL: readEnv('REACT_APP_AHM_KPI_REPORT_URL'),
  AHM_KPI_RUN_URL: readEnv('REACT_APP_AHM_KPI_RUN_URL'),
  COMPLIANCEGUARD_PORTAL_PATH: readEnv('REACT_APP_COMPLIANCEGUARD_PORTAL_PATH'),
  API_MATCH_URL: readEnv('REACT_APP_API_MATCH_URL'),
  LIFE_QUOTE_API_BASE: readEnv('REACT_APP_LIFE_QUOTE_API_BASE'),
  LIFE_QUOTE_LOGO_URL: readEnv('REACT_APP_LIFE_QUOTE_LOGO_URL'),
  POLARIS_APP_USER_ENDPOINT:
    readEnv('REACT_APP_POLARIS_APP_USER_ENDPOINT') || readEnv('POLARIS_APP_USER_ENDPOINT'),
  POLARIS_API_BASE_URL: readEnv('REACT_APP_POLARIS_API_BASE_URL'),
  SABAL_HIERARCHY_ENDPOINT_URL: readEnv('REACT_APP_SABAL_HIERARCHY_ENDPOINT_URL'),
  SABAL_HIERARCHY_ROSTER_ENDPOINT_URL: readEnv('REACT_APP_SABAL_HIERARCHY_ROSTER_ENDPOINT_URL'),
  SABAL_HIERARCHY_TIMEOUT_MS: readEnv('REACT_APP_SABAL_HIERARCHY_TIMEOUT_MS'),
  SABAL_HIERARCHY_CACHE_TTL_MS: readEnv('REACT_APP_SABAL_HIERARCHY_CACHE_TTL_MS'),
  EXEC_DASH_CACHE_TTL_MS: readEnv('REACT_APP_EXEC_DASH_CACHE_TTL_MS'),
  API_GATE_TOKEN: readEnv('REACT_APP_API_GATE_TOKEN'),
  AGENT_DIRECTORY_ENDPOINT: readEnv('REACT_APP_AGENT_DIRECTORY_ENDPOINT'),
  COMPLIANCE_SCORECARD_URL: readEnv('REACT_APP_COMPLIANCE_SCORECARD_URL'),
  AI_NPC_AGENT_LIST_URL: readEnv('REACT_APP_AI_NPC_AGENT_LIST_URL'),
  UPDATES_URL: readEnv('REACT_APP_UPDATES_URL'),
  POLARIS_ICON_URL: readEnv('REACT_APP_POLARIS_ICON_URL'),
  SLACK_CLIENT_ID: readEnv('REACT_APP_SLACK_CLIENT_ID'),
  SLACK_OAUTH_AUTHORIZE_URL: readEnv('REACT_APP_SLACK_OAUTH_AUTHORIZE_URL'),
};

export const getRequiredConfig = (value, label) => {
  if (!value) {
    console.warn(`Missing required config value: ${label}`);
  }
  return value;
};
